// Internal modules
import { features, logger } from '@/lib';
import { appStore } from '@/store';

const getCommonPayload = () => {
  const { showTabs } = appStore.getState().ui;
  const view_name = showTabs ? 'tab_view' : 'single_page_view';
  const forced_signup_offered = features.isActive('isForcedSignUp') ? 1 : 0;

  return {
    existingAccountCheck: {
      event_name: 'xo_guest_existing_account_check',
      field_name: 'email',
      forced_signup_offered,
      state_name: 'existing_account_check',
      view_name,
    },
    forced_signup_offered,
    view_name,
  };
};

export const logFptiForEmailChangeButtonClick = (): void => {
  const { forced_signup_offered, view_name } = getCommonPayload();

  logger.fpti('email_change_text_button_clicked', {
    event_name: 'xo_guest_change_email_button_clicked',
    field_name: 'email',
    forced_signup_offered,
    state_name: 'billing',
    transition_name: 'change_email_clicked',
    view_name,
  });
};
